(async function (algolia) {
  "use strict";

  const getAlgoliaResults = algolia.externals.getAlgoliaResults;
  const { config, translations, headerTemplate, faqsTemplate } = algolia;

  const index_suffix = await config.index_suffix;

  algolia.faqsPlugin = {
    getSources({ query }) {
      if (!query) {
        return [];
      }

      return [
        {
          sourceId: "faqs",
          getItems() {
            return getAlgoliaResults({
              searchClient: algolia.searchClient,
              queries: [
                {
                  indexName: 'gorgias_articles',
                  query,
                  params: {
                    hitsPerPage: config.pages_autocomplete_hits_per_page,
                    clickAnalytics: config.analytics_enabled,
                  },
                },
              ],
            });
          },
          templates: {
            header({ html, state }) {
              const resource = 'FAQs';
              return headerTemplate({ html, state }, resource);
            },
            item({ item, html, components }) {
              const itemLink = item.url;
              return faqsTemplate({ item, html, components }, itemLink);
            },
          },
        },
      ];
    },
  };
})(window.algoliaShopify);
